import { render, staticRenderFns } from "./BlogCardPost.vue?vue&type=template&id=5d84af53&"
import script from "./BlogCardPost.vue?vue&type=script&lang=js&"
export * from "./BlogCardPost.vue?vue&type=script&lang=js&"
import style0 from "./BlogCardPost.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports